import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Play } from 'lucide-react';

const Videos = () => {
  const { t } = useLanguage();
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videos = [
    {
      id: '1116408861',
      hash: '80fa76c500',
      title: t.videos.largo,
      thumbnail: 'https://customer-assets.emergentagent.com/job_e2580245-7f60-4bc0-a2e4-cf3b7d2c93e3/artifacts/2de4239l_05a726dd-173c-4b83-9e50-8e529e041a31.jpeg',
      embedUrl: 'https://player.vimeo.com/video/1116408861?h=80fa76c500&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    {
      id: '1120598630',
      hash: '2873b329ba',
      title: t.videos.corto,
      thumbnail: 'https://customer-assets.emergentagent.com/job_e2580245-7f60-4bc0-a2e4-cf3b7d2c93e3/artifacts/v8f1vijd_279198f3-8d40-449d-b5a9-a90ab2cfbf91.jpeg',
      embedUrl: 'https://player.vimeo.com/video/1120598630?h=2873b329ba&badge=0&autopause=0&player_id=0&app_id=58479'
    },
    {
      id: '1170165798',
      hash: '11f642aaf9',
      title: t.videos.debut,
      thumbnail: 'https://customer-assets.emergentagent.com/job_e2580245-7f60-4bc0-a2e4-cf3b7d2c93e3/artifacts/rhgrbqsc_4820cfe4-e26c-4049-9d0e-dab7a0252b94.jpeg',
      embedUrl: 'https://player.vimeo.com/video/1170165798?h=11f642aaf9&badge=0&autopause=0&player_id=0&app_id=58479'
    }
  ];

  return (
    <section id="videos" className="py-24 bg-gradient-to-b from-black to-zinc-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold mb-4 tracking-wide"
            style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          >
            {t.videos.title}
          </h2>
          <div className="h-1 w-20 bg-red-600 mx-auto mb-4" />
          <p className="text-gray-400 text-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {t.videos.subtitle}
          </p>
        </div>

        {/* Videos Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12">
          {videos.map((video, index) => (
            <div
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-xl aspect-video bg-black"
              onClick={() => setSelectedVideo(video)}
            >
              {/* Thumbnail */}
              <img
                src={video.thumbnail}
                alt={video.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />
              
              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-red-600 w-16 h-16 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-red-600/50">
                  <Play size={28} className="text-white ml-1" fill="white" />
                </div>
              </div>

              {/* Title */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3
                  className="text-white text-xl font-bold"
                  style={{ fontFamily: 'Oswald, sans-serif' }}
                >
                  {video.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Featured Video Player */}
        <div className="max-w-5xl mx-auto">
          <div className="relative aspect-video rounded-2xl overflow-hidden bg-black border border-white/10">
            <iframe
              key={selectedVideo ? selectedVideo.id : videos[0].id}
              src={selectedVideo ? selectedVideo.embedUrl : videos[0].embedUrl}
              className="w-full h-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
              allowFullScreen
              loading="lazy"
              title={selectedVideo ? selectedVideo.title : videos[0].title}
            ></iframe>
          </div>
          <p
            className="text-center text-gray-400 mt-4 text-lg"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {selectedVideo ? selectedVideo.title : videos[0].title}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Videos;
